import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { B02dUserAddPage } from '../b02d-user-add/b02d-user-add';
import { B02eUserInfoPage } from '../b02e-user-info/b02e-user-info';
import { B02UserManagementPage } from '../b02-user-management/b02-user-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B02cUserListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface userInfo{
  USER_ID: number;
  USER_NAME: string;
  BRANCH_ID: number;
  BRANCH_NAME: string;
  GRP_ID: number;
  GRP_NAME: string;
  CORP_ID: number;
  CORP_NAME: string;
  CORP_ACTIVE: string;  
}


@IonicPage()
@Component({
  selector: 'page-b02c-user-list',
  templateUrl: 'b02c-user-list.html',
})
export class B02cUserListPage {

  loading: any;
  Status: any;
  BRANCH_ID:any;
  userArr: userInfo[] = [];
  userItems: userInfo[] = [];
  public errorMessage: any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController) {

    this.BRANCH_ID = this.navParams.get('paramID');    //branch ID

    let tbl = ["USER"];
    let column = ["BRANCH_ID"];
    let value = [this.BRANCH_ID];
    
    let tblkey = ["BRANCH_ID", "GRP_ID"];
    let fktbl = ["BRANCH", "USER_GRP"];
    let fkkey = ["BRANCH_ID", "GRP_ID"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      
      if (this.Status == "1"){
        let Records = result["Records"];

        this.userArr = Records;
        this.userItems = this.userArr;
        console.log(this.userItems);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
        this.errorMessage = "Login Error. Please try again.";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02cUserListPage');
  }

  editUser(USER_ID){
    this.navCtrl.push(B02eUserInfoPage, {paramId: USER_ID});
  }

  goToAddUser(BRANCH_ID){
    this.navCtrl.push(B02dUserAddPage, {parambranchId: BRANCH_ID});
  }

  goTo(){
    this.navCtrl.setRoot(B02UserManagementPage);
  }

  showLoader(){    
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b02c-user-list/b02c-user-list.ts